import { Api } from '@monorepo/shared/apiClient';
import {
  DocumentFoldersCacheEvents,
  invalidateDocumentFoldersCache,
} from '@monorepo/shared/cacheRegisters/documents/documentFoldersCacheRegister';
import { DocumentFolderResponse } from 'mapistry-shared';
import { MutationConfig, useMutation } from 'react-query';

type UseCreateDocumentFolderParams = {
  config?: MutationConfig<DocumentFolderResponse, Api.ErrorResponse>;
};

export const useCreateDocumentFolder = (
  params?: UseCreateDocumentFolderParams,
) =>
  useMutation(Api.createDocumentFolder, {
    ...params?.config,
    onSuccess: (data, vars) => {
      invalidateDocumentFoldersCache(DocumentFoldersCacheEvents.CREATE, {
        organizationId: vars.organizationId,
      });
      return params?.config?.onSuccess?.(data, vars);
    },
  });
